import { createContext } from 'react'

/**
 * Entitlement restriction from billing.
 *
 * Semantics:
 * - `null` → No billing configured → Everything allowed (only RBAC applies)
 * - `[]` → Billing active, no features enabled → Nothing billing-controlled allowed
 * - `string[]` → Only these entitlements are billing-allowed
 *
 * TODO: After publishing frontend-kernel with EntitlementRestrictionContext,
 * import it from there instead of defining locally.
 */
export interface EntitlementRestriction {
  billingEntitlements: string[] | null
  isLoading: boolean
}

export const EntitlementRestrictionContext = createContext<EntitlementRestriction>({
  billingEntitlements: null,
  isLoading: false,
})
